module.exports = __webpack_public_path__ + "static/media/value-prop-icon-3.2e246b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value-prop-icon-3.svg
// module id = 1298
// module chunks = 0